import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\34\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './Download.css';
import React, { useMemo } from 'react';
import { canUseDOM, get, getColorByTheme, getColorClassByTheme, getPageThemeColors } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import IconDocument from '../atoms/Icons/IconDocument';
import IconDownload from '../atoms/Icons/IconDownload';
import { getGlobalDictionaryTerm } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { tealiumClickFunc, tealiumMergeClickData, getLastPartInURL } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
import RouterLink from '../atoms/RouterLink';
var Download = function Download(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    expanded = _React$useState2[0],
    setExpanded = _React$useState2[1];
  var theme = get(sitecoreContext, 'themesOfPage');
  var _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isVdsite = _React$useState4[0],
    setIsVdsite = _React$useState4[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var downloadListRef = React.useRef(null);
  var handleButtonClick = React.useCallback(function () {
    if (downloadListRef && downloadListRef.current) downloadListRef.current.focus();
    setExpanded(!expanded);
  }, [expanded]);
  var childrenSource = get(fields, 'data.item.children', []);
  var downloadsSource = get(fields, 'data.item.downloads.targetItems', []);
  var actualSSR = process.env.STORYBOOK_MODE ? false : sitecoreContext.route && sitecoreContext.route.fromSSR;
  var isMobile = useMemo(function () {
    return !actualSSR && canUseDOM && window.matchMedia("(max-width: 991px)").matches;
  }, [actualSSR]);
  if (!fields || !fields.data || !fields.data.item || !childrenSource.length && !downloadsSource.length) {
    console.info('Download component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", null, "[Downloads component is empty: please provide data source]");
    }
    return null;
  }
  var title = get(fields, 'data.item.title.jss');
  var data = fields.data;
  var numberOfCollapsedItems = Number(get(data, 'item.downloadsSettings.targetItem.numberOfCollapsedItems.value')) || 4;
  var hasItems = Boolean(get(downloadsSource, 'length')) || Boolean(get(childrenSource, 'length'));
  var items = hasItems ? downloadsSource.length ? downloadsSource : childrenSource : [];
  var showMoreText = get(data, 'item.downloadsSettings.targetItem.showMoreText.value', '');
  var showLessText = get(data, 'item.downloadsSettings.targetItem.showLessText.value', '');
  var hasButton = Boolean(showMoreText && showLessText && hasItems && items.length > numberOfCollapsedItems);
  var buttonText = expanded && showLessText || showMoreText;
  var downloadButtonText = get(data, 'item.downloadsSettings.targetItem.downloadButtonText.value');
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var variables = BackgroundColorHex ? {
    '--m12-multiply-background-color': BackgroundColorHex,
    '--m12-multiply-active-color': ActiveColorHex,
    '--m12-multiply-color': ColorHex
  } : {
    '--m12-multiply-background-color': primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    '--m12-multiply-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m12-multiply-color': getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var renderItems = function renderItems() {
    return items.slice(0, expanded || !hasButton ? Infinity : numberOfCollapsedItems).map(function (item, index, array) {
      if (item.title.jss && item.title.jss.value) {
        var newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || 'Opens in a new window';
        var linkTitle = "".concat(item.title.jss.value, " | ").concat(downloadButtonText, " | ").concat(newWindowLabel);
        return /*#__PURE__*/React.createElement("div", {
          className: "download-item ".concat(hasButton ? '' : 'download-item-more', " ").concat(index === 0 && title ? 'custom-padding-top' : '')
        }, index === 0 && title && /*#__PURE__*/React.createElement(Text, {
          tag: "h3",
          className: "h3 title--desk",
          "data-cy": "download-title",
          field: title
        }), /*#__PURE__*/React.createElement("div", {
          className: "download-item-content"
        }, /*#__PURE__*/React.createElement("div", {
          className: "content__img"
        }, /*#__PURE__*/React.createElement(IconDocument, {
          width: isMobile ? 48 : 32,
          height: isMobile ? 48 : 32,
          className: "content__img__icon"
        })), /*#__PURE__*/React.createElement("div", {
          className: "content__text"
        }, item.title.jss && /*#__PURE__*/React.createElement(Text, {
          tag: "h4",
          className: "download-item-title",
          "data-cy": "download-item-title",
          field: item.title.jss
        }), item.description.jss && /*#__PURE__*/React.createElement(Text, {
          tag: "p",
          className: "download-item-description",
          "data-cy": "download-item-description",
          field: item.description.jss
        }))), /*#__PURE__*/React.createElement("div", {
          className: "download-item-btn--wrapper"
        }, downloadButtonText && item.downloadLink.jss.value && item.downloadLink.jss.value.href && /*#__PURE__*/React.createElement(RouterLink, {
          className: "btn btn-primary download-item-btn",
          href: item.downloadLink.jss.value.href,
          "data-cy": "download-item-btn",
          onClick: function onClick() {
            return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['downloadButtonAnalytics'], params), getLastPartInURL(item.downloadLink.jss.value.href));
          },
          title: linkTitle,
          "aria-label": linkTitle,
          "aria-labelledby": linkTitle,
          linksTarget: "_blank"
        }, /*#__PURE__*/React.createElement("div", {
          className: "download-item-btn-content"
        }, downloadButtonText, /*#__PURE__*/React.createElement(IconDownload, {
          className: "download-item-btn__icon"
        }))), /*#__PURE__*/React.createElement("span", {
          className: "download-item-size",
          "data-cy": "download-item-size"
        }, item.downloadSize.jss.value)));
      }
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    style: variables,
    className: "download-module container ".concat(getColorClassByTheme(primaryPageThemeColor)),
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row download-section",
    "data-cy": "download",
    ref: downloadListRef,
    tabIndex: -1
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "download-items col-md-10"
  }, hasItems && items && renderItems(), hasButton && /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 btn-showmore-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-secondary btn-showmore",
    onClick: handleButtonClick,
    "data-cy": "download-showmore",
    tabIndex: 0
  }, buttonText)))))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    className = _ref2.className,
    style = _ref2.style;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className),
    style: style
  }, children);
};
export var commonStyles = "c1q3drr8";
export var ltrStyles = "l1rr9nxq";
export var rtlStyles = "r1k7n2v4";
export default Download;